<template>
  <div class="trial-duration-explanation">
    <div class="trial-duration-explanation__container">
      <div
        class="trial-duration-explanation__headline"
        v-html="$t('headline')" />

      <div class="trial-duration-explanation__timeline">
        <trial-timeline
          :plan="subscriptionPlan" />
      </div>

      <div class="trial-duration-explanation__try-blinkist">
        <inline-banner-with-cta
          :cta-copy="ctaCopy"
          :cta-js-class="ctaJsClass"
          :piwik-category="piwikCategory" />
      </div>
    </div>
  </div>
</template>

<script>
import InlineBannerWithCta from "/shared/inline-banner-with-cta";
import TrialTimeline from "/features/trial-duration-explanation/components/trial-timeline";

export default {
  components: {
    InlineBannerWithCta,
    TrialTimeline
  },
  i18n: {
    messages: {
      en: { headline: "Curious? <br>Try it for free" },
      de: { headline: "Das kostenlose Probeabo" }
    }
  },
  props: {
    ctaCopy: {
      type: String,
      default: null
    },
    ctaJsClass: {
      type: String,
      default: null
    },
    piwikCategory: {
      type: String,
      default: null
    },
    subscriptionPlan: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss">
.trial-duration-explanation {
  @include font-family(sans-serif);

  display: flex;
  align-items: flex-end;

  padding: $spacing-64 0;

  &__container {
    @include container;
  }

  &__headline {
    @include font-style(h2);

    width: 100%;
    margin-bottom: $spacing-32;

    text-align: center;

    br { /* stylelint-disable-line selector-nested-pattern */
      @include media(min-width, m) {
        display: none;
      }
    }

    @include media(min-width, m) {
      margin-bottom: $spacing-64;
    }
  }

  &__timeline {
    margin-bottom: $spacing-128;

    @include media(min-width, m) {
      margin-bottom: $spacing-96;
    }
  }
}
</style>
